import React from "react";
import styles from "./Barcode.module.css";

const Barcode = ({ productBarcode }) => {
  return <p className={styles.confirmation__barcode}>{productBarcode}</p>;
};

export default Barcode;
